// libs
import React, { memo, Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Container, ProductTagsContainer, Seperator } from './styles';

// components
import ProductTag from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductTag';
import Badge from 'shared/layouts/DetailsPage/components/ProductInfo/components/Badge';

// defs
import { IMultitag } from './types';

function Multitag({ productTags, badge }: IMultitag) {
  const noOfTags = productTags.length;

  if (isEmpty(badge) && isEmpty(productTags)) {
    return null;
  }

  return (
    <Container data-test="multitag-container">
      {badge && <Badge value={badge} />}
      <ProductTagsContainer>
        {productTags.map((tag, i) => {
          return (
            <Fragment key={i}>
              <ProductTag productTag={tag} data-test="product-tag" />
              {noOfTags > 1 && i < noOfTags - 1 && <Seperator />}
            </Fragment>
          );
        })}
      </ProductTagsContainer>
    </Container>
  );
}

export default memo(Multitag);
